import types from '../types';
import { uri } from 'utils';

/**
 * @param {string} checkboxGroupValueInURL
 * @param {string} filterId
 * @returns {boolean}
 */
const isChecked = (checkboxGroupValueInURL, filterId) =>
    uri
        .decode(checkboxGroupValueInURL)
        .split(uri.VALUE_SEPARATOR)
        .includes(filterId.toString());

/**
 * @param {types.Option[]} defaultValues
 * @param {string} url
 * @param {string} checkboxGroupId
 * @returns {types.Option[]}
 */
export default function getCheckboxGroupStateFromURL(
    defaultValues,
    url,
    checkboxGroupId
) {
    const checkboxGroupValueInURL = uri.getParams(url)[checkboxGroupId];

    // No params in URL, skip merging and use the defaults
    if (!checkboxGroupValueInURL) {
        return defaultValues;
    }

    return defaultValues.map(option => {
        const nextOption = {
            ...option,
            checked: isChecked(checkboxGroupValueInURL, option.id)
        };

        if (option.subOptions && option.subOptions.length) {
            nextOption.subOptions = option.subOptions.map(subOption => {return {
                ...subOption,
                checked: isChecked(checkboxGroupValueInURL, subOption.id)
            }});
        }

        return nextOption;
    });
}
